import alt from '../alt';
import modalAction from './modalAction';

class leaveAtdAction {
    constructor() {
        this.generateActions(
            'processing',
            'staffId',
            'summary',
            'isLeaveSuccess',
            'isAtdSuccess',
        );
    }
    markAttendate(staffId, year, month, date, startTime, startLocation,
        startRemark, endTime, endLocation, endRemark) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/attendance/staff/apply', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        this.isAtdSuccess(true);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Attendance marked. Page will be refresh in 3 seconds" });
                        modalAction.modalClose(true);
                    }else{
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            }
            xhttp.send(JSON.stringify({
                staffId: staffId,
                year: year,
                month: month,
                date: date,
                startTime: startTime,
                startLocation: startLocation,
                startRemark: startRemark,
                endTime: endTime,
                endLocation: endLocation,
                endRemark: endRemark
            }));
        }
        return true;
    }
    applyStaffLeave(fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/leave/staff/apply', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {

                    if (xhttp.status == 200) {
                        this.isLeaveSuccess(true);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Leave applied. Page will be refresh in 3 seconds" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
    getSummary(staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/leave/summary/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.summary(result.summary);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
}

export default alt.createActions(leaveAtdAction);


// WEBPACK FOOTER //
// ./app/actions/leaveAtdAction.js